<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Empaque
            <router-link :to="{ name: 'Empaques' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>

            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="nombreEmpaque"
                  :isValid="checkIfValid('nombreEmpaque')"
                  label="Nombre del empaque:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CSelect
                  :value.sync="nombreCultivo"
                  :isValid="checkIfValid('nombreCultivo')"
                  label="Cultivo:"
                  placeholder="Cultivo..."
                  invalidFeedback="Campo requerido, debe seleccionar una opción"
                  :options="cultivos"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.costo.$model"
                  :isValid="checkIfValid('costo')"
                  label="Costo"
                  placeholder="Costo.."
                  type="number"
                  prepend="$"
                  invalidFeedback="Campo requerido"
                  @click="()=>costo=costo==0?'':costo"
                />
              </CCol>
            </CRow>
            <!-- <img width="50" height="50" src="data:image/png;base64, YOUR_BASE64_STRING_FROM_RESPONSE" :alt="urlName" /> -->
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Empaques' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton class="px-4 mx-3 btn-lg" @click="addEmpaque()" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Empaques"
      :centered="true"
      color="warning"
      :show="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import "vue-select/dist/vue-select.css";

export default {
  name: "EditarEmpaque",

  components: {
  },

  data() {
    return {
      id: this.$route.params.id,
      item: {},
      nombreEmpaque: "",
      nombreCultivo: "",
      costo: "",
      isLoading: false,
      configuracion: [],
      url: "",
      urlName: "",
      warningModal: false,
      error: "",
      isLoadingPage: false,
      isLoadingCombos: false
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreEmpaque: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(100)
    },
    nombreCultivo: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    },
    costo: {
      required,
      notNegative: (value) => value >= 0
    },
  },

  computed: {
    isValidEmpaque() {
      return !this.nombreEmpaque.$invalid;
    },
    isValidCultivo() {
      return !this.$v.nombreCultivo.$invalid ;
    },
    isValidCosto() {
      return !this.$v.costo.$invalid ;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    cultivos() {
      return this.configuracion.map(cultivo => {
        return cultivo.nombre
      })
    }
  },

  created() {
    this.isLoadingPage = true;

    this.$store.dispatch('customHTTP', {
      schema: 'configuracion',
      filter: {
        where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
      }
    }).then((configuracion) => {
      this.configuracion = configuracion.data[0].payload.valor
    }).finally(() => (this.isLoadingPage = false));
    const tra = [
      this.$store.dispatch("customHTTP", {
        schema: "empaques",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    Promise.all(tra)
      .then(([item]) => {
        this.item = item.data[0];
        this.nombreEmpaque = this.item.payload.nombre;
        this.nombreCultivo = this.item.payload.cultivo;
        this.costo = this.item.payload.costo;
       
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },
    addEmpaque() {
      this.validateEmpaque();
      if (
        this.isValidEmpaque &&
        this.isValidCultivo &&
        this.isValidCosto
      ) {
        this.isLoading = true;

        
          this.$store
            .dispatch("customActualizarHTTP", {
              schema: "empaques",
              id: this.id,
              payload: {
                nombre: this.nombreEmpaque,
                cultivo: this.nombreCultivo,
                costo: this.costo,
              }
            })
            .then(() => {
              this.$router.push({ name: "Empaques" });
            })
            .catch(rej => {
              // console.log(rej);
              this.error = rej.message;
              this.warningModal = true;
            })

            .finally(() => {
              this.isLoading = false;
            });
        
      }
    },
    getImage(media) {
      this.isLoading = true;
      this.$store
        .dispatch("customImageObtenerHTTP", {
          media: media
        })
        .then(blob => {
          // this.url = `data:image/png;charset=utf-8;base64, ${res}`;
          // const b64Response = btoa(unescape(encodeURIComponent(blob)));

          // console.log(b64Response);

          // const str2 = decodeURIComponent(escape(window.atob(b64Response)));
          // console.log(str2);

          // let reader = new FileReader();
          // reader.onloadend = function() {
          //   this.url = reader.result;
          // };
          // reader.readAsDataURL(res);
          //this.url = `data:image/jpg;charset=utf-8;base64, ${b64Response}`;
          this.url = window.URL.createObjectURL(blob);
          // this.url = blob;
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field === "");
    },
    validateEmpaque() {
      this.$v.nombreEmpaque.$touch();
      this.$v.nombreCultivo.$touch();
      this.$v.costo.$touch();
      // this.equivalencia_6oz;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.sp-width {
  max-width: 400px !important;
  height: auto !important;
  /* object-fit: contain; */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
